import { Component, OnInit, Output, EventEmitter, Inject  } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { first } from 'rxjs/operators';
import { AppComponent } from '../../app.component';

import { AuthenticationService } from '../../_services';
// para formulario
import { MatSnackBar} from '@angular/material/snack-bar';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material';
import { MatIconModule} from '@angular/material/icon'; 


@Component({
  selector: 'app-restaurar',
  templateUrl: './restaurar.component.html',
  styleUrls: ['./restaurar.component.scss']
})
export class RestaurarComponent implements OnInit {
  password: FormControl;
  passwordConfirm: FormControl;
  loading = false;
  submitted = false;
  returnUrl: string;
  error: string;
  success: string;
  currentRole: any;
  correo_restaurar: any;
  token_restauracion: any;
  response: any;
  session_expirada = true;
  mostrar_content = false;
  password_coincide = false;
  confirmar_escrita = false;
  password_incorrecta = false;
  mensaje_success = false;
  spinner = false;
  always = true;
  error_cambiar = false;

  restaurarForm: FormGroup;
  el_correo: string;

  constructor(private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    public dialog: MatDialog,
    private snackBar: MatSnackBar)
  {
  	// console.log("los params son "+this.route.snapshot.queryParams['solicitud']);
  	// console.log(this.route.snapshot);
  	this.token_restauracion = this.route.snapshot.queryParams['solicitud'];
  	if(this.token_restauracion){
  		this.authenticationService.consultarFolioRestauracion(this.token_restauracion)
  		.pipe(first())
      .subscribe(
        data => {
          // console.log("response fue");
          // console.log(data);
          if(data.result == 200){
		  			this.correo_restaurar = data.correo;
		  			this.session_expirada = false;
		  		}else if(data.result == 202){
		  			// console.log("token expirado")
		  			this.session_expirada = true;
		  		}else{
		  			this.router.navigate(['/']);
		  		}
		  		this.mostrar_content = true;
        },
        error => {
          this.session_expirada = true;
          this.mostrar_content = true;
      });
  	}else{
  		// console.log("session_expirada")
  		this.session_expirada = true;
  		this.mostrar_content = true;
  	}
  	
  }

  ngOnInit() {

  	this.password = new FormControl('', [
      Validators.required,
      Validators.minLength(8),
    ]);

    this.passwordConfirm = new FormControl('', [
      Validators.required
    ]);
  }

  verificarPasswords(){
  	this.confirmar_escrita = true;
  	this.password_incorrecta = false;
  	if(this.password.value == this.passwordConfirm.value){
  		this.password_coincide = true;
  	}else{
  		this.password_coincide = false;
  	}
  	// console.log("password_coincide es " +this.password_coincide);
  }

  returnLogin(){
  	this.router.navigate(['/']);
  }

  onSubmit(){
  	this.spinner = true;
  	this.loading = true;
  	// console.log("Restaurar contraseña")
  	if(this.session_expirada || this.error_cambiar){
  		this.router.navigate(['/']);
  	}else{
  		if(this.password_coincide){
  			// console.log("Token bien");
  			this.authenticationService.cambiarPassword(this.token_restauracion, this.password.value)
		  		.pipe(first())
		      .subscribe(
		        data => {
		          // console.log("response fue");
		          // console.log(data);
		          if(data.result == 200){
		          	this.loading = true;
		          	this.mensaje_success = true;
		          	this.spinner = false;
				  		}else{
				  			this.error_cambiar = true;
				  			this.loading = true;
				  			this.spinner = false;
				  		}
		        },
		        error => {
		          this.session_expirada = true;
		          this.mostrar_content = true;
		          this.spinner = false;
		      });
  		}else{
        this.spinner = false;
  			this.password_incorrecta = true;
  			// console.log("password no coincide");
  			return;
  		}
  		
  	}
  }

}
